import React from 'react';
import styles from './DynascoreRow.module.css';

const DynascoreRow = ({ comp, genre }) => {
  const goToDynascore = (prefixKey) => {
    window.location.href = '/dynascore/browse/dynascore/' + comp.prefixKey;
  };
  return (
    <div
      key={comp.prefixKey}
      className={styles.dynascoreRow}
      onClick={() => goToDynascore(comp.prefixKey)}
    >
      <div className={styles.dynascoreName}>{comp.name}</div>
      <div className={styles.dynascoreGenre}>{genre}</div>
      <div className={styles.artistName}>{comp.artist}</div>
      <a
        className={styles.listenButton}
        href={'/dynascore/browse/dynascore/' + comp.prefixKey}
      >
        Listen
      </a>
    </div>
  );
};

export default DynascoreRow;
